import get from 'lodash.get';
import uniq from 'lodash.uniq';
import { format } from 'date-fns';
import { selectFertilizerEvents } from 'services/fertilizerEvents/selectors';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { FertilizerEventUuid } from 'services/fertilizerEvents/types';

import { selectSelectedIncompleteFertilizerEventsUuids } from '../FertilizerEventsVirtualizedTable/selectors';

const selectSelectedFertilizerEventDates = createDeepEqualSelector(
    selectFertilizerEvents,
    selectSelectedIncompleteFertilizerEventsUuids,
    (fertilizerEvents, uuids: FertilizerEventUuid[]) => {
        const dates = uuids.map((uuid) => {
            const date = get(fertilizerEvents, [uuid, 'startDate']);

            if (date) {
                return format(new Date(date), 'dd/MM/yyyy');
            }

            return '';
        });

        return uniq(dates);
    }
);

export { selectSelectedFertilizerEventDates };
